import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeMenages = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"Listemenagereport"} />
        </div>
    );
}
export default ListeMenages;